// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"8d1dc597","713":"89185bd8"}[chunkId] + ".chunk.js";
};